export default __webpack_public_path__ + "static/media/2_0026.be6b3fcf.webp";